import { render } from "./AvatarMenu.vue?vue&type=template&id=0dfbd173&ts=true"
import script from "./AvatarMenu.vue?vue&type=script&lang=ts"
export * from "./AvatarMenu.vue?vue&type=script&lang=ts"

import "./AvatarMenu.vue?vue&type=style&index=0&id=0dfbd173&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__